import React from 'react';
import { ShieldCheckIcon, LockIcon, ZapIcon, CreditCardIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
const rows = [{
  label: '📘 The Autonomous Child Visual System™ (50-page eBook, 6 volumes)',
  price: '$27'
}, {
  label: '🎨 Bonus #1: The Neuro-Friendly Icon Vault',
  price: 'FREE'
}, {
  label: '🗓️ Bonus #2: Weekend & Holiday Transition Guide',
  price: 'FREE'
}, {
  label: '💬 Bonus #3: Power Struggle Script Book',
  price: 'FREE'
}, {
  label: '✈️ Bonus #4: Print-and-Go Travel Routine Cards',
  price: 'FREE'
}, {
  label: '😴 Bonus #5: The Sleep-Anchor Checklist',
  price: 'FREE'
}, {
  label: '🛡️ 7-Day Money-Back Guarantee',
  price: 'INCLUDED'
}, {
  label: '♾️ Lifetime access & future updates',
  price: 'INCLUDED'
}];
const trust = [{
  icon: LockIcon,
  label: '100% Secure Payment'
}, {
  icon: ZapIcon,
  label: 'Instant Access'
}, {
  icon: ShieldCheckIcon,
  label: '7-Day Guarantee'
}, {
  icon: CreditCardIcon,
  label: 'Debit / Credit'
}];
export function ValueStack() {
  return <section id="value" aria-label="Offer summary" className="border-y border-grape/10 bg-white/70" data-id="element-197" data-mp="1tg4qg3i791jt">
      <div className="mx-auto max-w-2xl px-5 py-12 text-center" style={{
      paddingTop: "13px",
      paddingBottom: "25px"
    }} data-id="element-198" data-mp="1ohuwfw87o6zs">
        <h2 className="font-display text-2xl font-black text-plum sm:text-4xl" data-id="element-199" data-mp="23796l6jm2sg8">
          🚀 Transform your family’s routine today
        </h2>
        <p className="mx-auto mt-3 max-w-xl text-sm text-plum/60" data-id="element-200" data-mp="2c5bco0i7cbad">
          Stop repeating. Start watching your child organize themselves. One single payment,
          lifetime access, everything ready to print and use today.
        </p>

        <div className="mt-10 overflow-hidden rounded-2xl border border-grape/15 bg-cream text-left" data-id="element-201" data-mp="2m392utjmgi5m">
          <div className="flex items-center justify-between border-b border-grape/10 px-5 py-3 text-xs font-bold uppercase tracking-wide text-plum/55" data-id="element-202" data-mp="2h5qpmqykngrt">
            <span data-id="element-203" data-mp="mrg52up0f8ru">What's included</span>
            <span data-id="element-204" data-mp="mshhb2hri1b5">Price</span>
          </div>
          {rows.map(r => <div key={r.label} className="flex items-center justify-between gap-4 border-b border-grape/10 px-5 py-3.5 text-sm" data-id="element-205" data-mp="2mtxqe5sf68jv">
              <span className="text-plum/80" data-id="element-206" data-mp="2rssixzg6vbh6">{r.label}</span>
              <span className={r.price.startsWith('$') ? 'shrink-0 font-bold text-blush' : 'shrink-0 font-bold text-grape'} data-id="element-207" data-mp="2vtcgv58l6j4d">
                {r.price}
              </span>
            </div>)}
          <div className="flex flex-col items-center gap-1 bg-lilac-soft px-5 py-6 text-center" data-id="element-208" data-mp="35s9zjrjbzifg">
            <span className="text-sm font-bold text-plum" style={{
            fontSize: "16px"
          }} data-id="element-209" data-mp="3aqv1bve8ea60">
              Real total value: <span className="text-plum/40 line-through" data-id="element-210" data-mp="3fhl89d2b2l2t">$211</span>
            </span>
            <span className="text-grape-shine font-display text-5xl font-black leading-none sm:text-6xl" style={{
            fontSize: "72px",
            fontFamily: "Montserrat, sans-serif",
            paddingTop: "8px",
            paddingBottom: "11px",
            fontWeight: "800"
          }} data-id="element-211" data-mp="3jjycfx1emaxh">
              $27
            </span>
            <span className="text-xs font-semibold uppercase tracking-wide text-plum/60" data-id="element-212" data-mp="3tf9qed4zne46">
              USD · One-time payment · No monthly subscription
            </span>
            <span className="mt-1 text-[11px] font-medium text-plum/50" style={{
            fontWeight: "600"
          }} data-id="element-213" data-mp="2fhfeify9plx">
              Payment will be processed in your local currency.
            </span>
          </div>
        </div>

        <div className="mt-9 flex justify-center" data-id="element-214" data-mp="3pnuv5mub8of5">
          <CTAButton data-id="element-215" data-mp="q6wk2hv78j0c">Get the visual system now</CTAButton>
        </div>

        <p className="mt-3 text-xs font-semibold text-plum/55" data-id="element-216" data-mp="l7k1487g7w31">
          You save $184 USD (87% OFF) · One-time payment · Lifetime access
        </p>
        

        <div className="mt-8 flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-xs font-medium text-plum/55" data-id="element-217" data-mp="gf0kt3hdmmuj">
          {trust.map(({
          icon: Icon,
          label
        }) => <span key={label} className="inline-flex items-center gap-1.5" data-id="element-218" data-mp="18xxsdwi7lqwk">
              <Icon className="h-4 w-4 text-grape" data-id="element-219" data-mp="145wb1w66p9zo" />
              {label}
            </span>)}
        </div>
      </div>
    </section>;
}